// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._9wgok{display:inline-flex;height:22px;align-items:center;grid-gap:4px;gap:4px}.gXkz8{width:22px;height:22px;background-color:#f4e600;border-radius:50%;color:#232323}.gXkz8,.HZVS-{display:flex;align-items:center;justify-content:center}.HZVS-{height:100%;padding:0 12px;border-radius:100px;font-size:14px;line-height:20px}.HZVS-.wctCk{background-color:#f4e600;color:#232323}.HZVS-.NeyGp{background-color:#00a6a6;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_9wgok",
	"icon": "gXkz8",
	"text": "HZVS-",
	"yellow": "wctCk",
	"mint": "NeyGp"
};
module.exports = ___CSS_LOADER_EXPORT___;
